/**
 * When you want to append a bunch of nodes to a parent element in a specific place,
 * this class helps you keep track of where you last inserted a node.
 *
 * Instead of something like this, which can get annoying when
 * running across multiple functions:
 * ```
 * lastNode = insertAfter(parentNode, newNode, lastNode);
 * lastNode = insertAfter(parentNode, anotherNode, lastNode);
 * lastNode = insertAfter(parentNode, yetAnotherNode, lastNode);
 * ```
 * Do this
 * ```
 * const cursor = new DOMCursor(parentNode);
 * cursor.appendChild(newNode);
 * cursor.appendChild(anotherNode);
 * cursor.appendChild(yetAnotherNode);
 * ```
 * Allows re-positioning the cursor to a specific node.
 */
export class DOMCursor {
    constructor(
        private readonly root: HTMLElement,
        private lastNode: Node | null = root.firstChild,
    ) {}

    /**
     * When null, the cursor will start appending nodes after the root's last child
     */
    positionAt(node: Node | null) {
        this.lastNode = node;
    }

    appendChild(node: Node) {
        this.lastNode = insertAfter(this.root, node, this.lastNode);
    }
    moveChildToCursor(node: Node) {
        this.lastNode = insertAfter(this.root, node, this.lastNode);
    }
}
function insertAfter(parent: HTMLElement, newNode: Node, referenceNode: Node | null): Node {
    parent.insertBefore(newNode, referenceNode?.nextSibling ?? null);
    return newNode;
}
